import { useCreateManualAdjustmentMutation, ManualAdjustmentReasonType, IncrementOrDecrement } from '../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useCreateManualAdjustment() {
	const [ createManualAdjustment, createManualAdjustmentState ] = useCreateManualAdjustmentMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	const createManualAdjustmentWrapper = async(
		storeId: string,
		reason: ManualAdjustmentReasonType,
		items: {
			productId: string,
			quantity: number,
			costPerItem: number,
		}[],
		direction: IncrementOrDecrement,
		memo?: string,
	) => {
		const result = await createManualAdjustment( { variables: {
			inventoryLocationId: storeId,
			items,
			memo,
			reason,
			direction
		} } )

		if ( result.data?.createManualAdjustment?.success ) {
			showSuccess( `createStoreSuccess${Date.now()}`, result.data?.createManualAdjustment?.message )
		} else if ( result.data?.createManualAdjustment?.message ) {
			showError( `createStoreError${Date.now()}`, result.data?.createManualAdjustment?.message ?? 'Sorry, an error occurred' )
		}
	}

	return {
		createManualAdjustment: createManualAdjustmentWrapper,
		createManualAdjustmentState,
	}
}
